module.exports = __webpack_public_path__ + "img/linkedin.7b850da6.svg";